/**
 * Created by Paul Olle on 16.11.2021
 */

// imports
import {Brick, registerBrick, BrickContext} from 'olympe';
import React from 'react';
import ReactDOM from 'react-dom';
import {UserDefaultsContent} from './user_defaults/UserDefaultsContent.jsx';

/**
 * Brick that display a popup for the user settings
 */
export default class ShowUserDefaultsPopup extends Brick {
    /**
     * Executed every time the brick receives a new trigger event.
     * Note that the method will be executed _even if_ an input (userDefaults) is undefined.
     *
     * @protected
     * @param {BrickContext} context
     * @param {*} userDefaults
     * @param {*} getMasterData
     * @param {*} getAddressFromStorageLocation
     * @param {*} getAddressFromPlant
     * @param {*} getUsersAPI
     * @param {*} user
     * @param {*} userSettings
     * @param {string} adminAppUserList
     * @param {*} superUserList
     * @param {string} currentUser
     * @param {function()} forwardEvent
     * @param {function(boolean)} setToSave
     * @param {function(*)} setObject
     */
    update(
        context,
        [userDefaults, getMasterData, getAddressFromStorageLocation, getAddressFromPlant, getUsersAPI, user, userSettings, adminAppUserList, superUserList, currentUser],
        [forwardEvent, setToSave, setObject],
    ) {
        if (userDefaults) {
            const popupId = 'popup017d2dfe5b68a3663ce9';
            if (!document.getElementById(popupId)) {
                const popup = document.createElement('div');
                popup.id = popupId;
                document.body.appendChild(popup);
            }
            ReactDOM.render(
                <ShowUserDefaultsPopup.Component
                    forwardEvent={forwardEvent}
                    userDefaults={userDefaults}
                    saveCallback={(ud, transaction) => {
                        userDefaults.setFromLabelValueObject(transaction, ud);
                        setObject(userDefaults);
                    }}
                    setToSave={setToSave}
                    context={context}
                    getMasterData={getMasterData}
                    getUsersAPI={getUsersAPI}
                    user={user}
                    userSettings={userSettings}
                    adminAppUserList={adminAppUserList}
                    superUserList={superUserList}
                    currentUser={currentUser}
                />,
                document.getElementById(popupId),
            );
        }
    }
}


/**
 * @param {ShowUserDefaultsPopup.Component.propTypes} props
 * @return {JSX.Element}
 * @constructor
 */
ShowUserDefaultsPopup.Component = (props) => {
    return (
        <UserDefaultsContent {...props}/>
    );
};

registerBrick('017d2dfe5b68a3663ce9', ShowUserDefaultsPopup);
